import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  header: FelaCSS;
}

const styles: IStyles = {
  header: {
    color: colors.space,
    fontDefaultSemiBold: 22,
    minHeight: 40,
    justifyContent: 'center',
    marginTop: 0,
    marginBottom: 2,
    flexBasis: '100%',
  },
};

export default styles;
